import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { defaultHeaders } from '@redux/api/Config';
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import config from '@app/config';
import { FetchActionsByBrandDto } from '@entities/Actions/module/services/api.dto';
import { ActionByBrand } from '@entities/Actions/module/types/actionSchema';

function isHydrateAction(action: Action): action is PayloadAction<any> {
  return action.type === HYDRATE;
}

export const actionApi = createApi({
  reducerPath: 'actionApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.baseApiUrl,
    prepareHeaders: defaultHeaders,
  }),
  extractRehydrationInfo(action, { reducerPath }): any {
    if (isHydrateAction(action)) {
      return action.payload[reducerPath];
    }
  },
  endpoints: builder => ({
    getActionByBrand: builder.query<ActionByBrand[], FetchActionsByBrandDto>({
      query: ({ brand, part, regionId }) => `/api/actions/get-by-brand?brand=${brand}&part=${part}&regionId=${regionId}`,
      transformResponse: (response: { data: ActionByBrand[] }) => response.data,
    }),
  }),
});

export const { useGetActionByBrandQuery, endpoints } = actionApi;
